export default "__VITE_ASSET__k4ukmF6T__"